import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
export interface NavProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

/**
 * Navigation container for navbar items (desktop only)
 */
function Nav(t0) {
  const $ = _c(12);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const hasManyItems = Array.isArray(children) && children.length > 3;
  const t1 = !hasManyItems;
  let t2;
  if ($[4] !== className || $[5] !== hasManyItems || $[6] !== t1) {
    t2 = cn("hidden items-center gap-2 lg:flex xl:gap-12", {
      "lg:gap-6": hasManyItems,
      "lg:gap-12": t1
    }, className);
    $[4] = className;
    $[5] = hasManyItems;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== props || $[10] !== t2) {
    t3 = <nav className={t2} {...props}>{children}</nav>;
    $[8] = children;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
Nav.displayName = 'NavbarNav';
export { Nav };